<template>
  <div class="sw-modal">
    <div class="sw-modal-content">
      <div class="sw-modal-heading">
        <div class="col text-center">
          <h1>Check-in</h1>

          <div>
            <button v-bind:class="{'invisible' : !showPreviousDayButton}" v-on:click="previousDay()" class="hover-button">
              <i class="fas fa-angle-left"></i>
            </button>
            <h4>{{checkInDateString}}</h4>
            <button v-bind:class="{'invisible' : !showNextDayButton}" v-on:click="nextDay()" class="hover-button">
              <i class="fas fa-angle-right"></i>
            </button>
          </div>

        </div>
      </div>
      <div class="sw-modal-body">
        <table class="check-ins">
          <thead>
          <th>Main Guest</th>
          <th class="text-center">{{getUnitTypeForDisplay}}</th>
          <th class="text-center">No. Guests</th>
          <th></th>
          </thead>
          <tr v-show="loading">
            <td colspan="4" class="check-ins__loading">
              <Spinner/>
            </td>
          </tr>
          <tr v-show="!loading" v-for="(form, index) in forms" v-bind:key="index">
            <td v-if="index === 0 || form.booking.reference !== forms[index - 1].booking.reference">{{form.booking.guest.firstName}} {{form.booking.guest.lastName}}</td>
            <td v-else></td>
            <td v-if="index === 0 || form.booking.reference !== forms[index - 1].booking.reference" class="text-center">{{form.booking.rooms.length}}</td>
            <td v-else></td>
            <td v-if="index === 0 || form.booking.reference !== forms[index - 1].booking.reference" class="text-center">{{totalGuests(form.booking)}}</td>
            <td v-else></td>
            <td class="text-right">
              <template v-if="!form.completed">
                <a v-bind:href="url(form.reference)" v-on:click="close" target="_blank">
                  <button class="btn btn-primary">{{form.formTitle}}</button>
                </a>
              </template>
              <template v-else>
                <i class="fas fa-check text-success"></i>
              </template>
            </td>
          </tr>
          <tr v-show="!loading" v-if="forms.length === 0">
            <td colspan="4" class="text-center">
              No check-ins
              <template v-if="isCheckInDateToday">today</template>
              <template v-else>on {{friendlyDate(checkInDate)}}</template>
            </td>
          </tr>
        </table>
      </div>
      <div class="sw-modal-actions text-center">
        <button v-on:click="close" class="btn btn-secondary">Close</button>
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs'

import { datesMixin } from '../../mixins/DatesMixin'

import Spinner from '../Spinner.vue'

export default {
  name: 'ListForms',
  components: { Spinner },
  mixins: [datesMixin],
  props: {
    frontDeskURL: String,
    frontDesk: Object
  },
  data: function () {
    return {
      loading: false,
      forms: [],
      checkInDate: dayjs().startOf('day')
    }
  },
  computed: {
    getUnitTypeForDisplay: function () {
      switch (this.frontDesk.displayCategoryForRoomTypes) {
        case 'unit':
          return 'Units'
        case 'property':
          return 'Properties'
        case 'room':
        default:
          return 'Rooms'
      }
    },
    isCheckInDateToday: function () {
      return dayjs().startOf('day').isSame(this.checkInDate)
    },
    checkInDateString: function () {
      return this.friendlyDateFull(this.checkInDate)
    },
    showPreviousDayButton: function () {
      const minCheckInDay = dayjs().startOf('day').subtract(6, 'days')
      if (this.checkInDate.isAfter(minCheckInDay)) {
        return true
      }
      return false
    },
    showNextDayButton: function () {
      const maxCheckInDay = dayjs().startOf('day')
      if (this.checkInDate.isBefore(maxCheckInDay)) {
        return true
      }
      return false
    }
  },
  methods: {
    previousDay: function () {
      this.checkInDate = this.checkInDate.subtract(1, 'days')
      this.fetchForms()
    },
    nextDay: function () {
      this.checkInDate = this.checkInDate.add(1, 'days')
      this.fetchForms()
    },
    fetchForms: async function () {
      this.loading = true
      let url = '/guest/v1/front-desk/' + this.frontDeskURL + '/forms'
      if (!this.isCheckInDateToday) {
        url += '/' + this.checkInDate.format('YYYY-MM-DD')
      }

      const fetchResult = this.$http.get(url).then(response => {
        this.forms = response.data
      }).catch(error => {
        console.log(error)
        if (error.response) {
          // client received an error response (5xx, 4xx)
          // this.errorMessage = 'Sorry, but we couldn\'t load your form properly. Please try again'
        } else {
          // this.errorMessage = 'Sorry, we\'re having problems preparing your form. Please try again'
        }
      })

      // use Promise.all so that we show the spinner for at least 300 msecs
      Promise.all([
        fetchResult,
        new Promise(resolve => setTimeout(resolve, 300))
      ]).then(() => { this.loading = false })
    },
    totalGuests: function (booking) {
      let tot = 0
      booking.rooms.forEach(r => {
        tot = tot + r.numberOfAdults
        tot = tot + r.numberOfChildren1
        tot = tot + r.numberOfChildren2
      })
      return tot
    },
    url: function (reference) {
      return '/?fr=' + reference
    },
    close: function () {
      this.$root.$emit('list-forms-closed')
    }
  },
  mounted: async function () {
    this.fetchForms()
  }
}

</script>

<style lang="scss" scoped>
  @import "../../styles/layout/icons";
  @import "../../styles/components/modal";
  @import "../../styles/components/front-desk";
</style>
